export default {
  name: 'business-hours',
  translationKey: 'business-hours-module',
  routePrefix: 'business-hours',
  routeNamePrefix: 'admin.business-hours',
  directRoutesAvailable: false,
}
